import { Box, Theme, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";

const StatusCardHeader = ({
    title,
    icon,
    backgroundColor,
}: {
    title: string;
    icon: JSX.Element;
    backgroundColor: string;
}) => {
    return (
        <Box
            sx={(theme: Theme) => ({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 32,
                backgroundColor: backgroundColor,
                color: theme.palette.common.white,
                padding: theme.spacing(1),
            })}
        >
            <CustomIcon icon={icon} sx={{ marginRight: 1, fontSize: 16 }} />
            <Typography variant="body1" sx={{ fontSize: 12, letterSpacing: "1.25px" }}>
                {title}
            </Typography>
        </Box>
    );
};

export default StatusCardHeader;
